//广告管理
import jmAdvHome from '@/components/jm/adv/home.vue'
//广告投放商管理
import jmAdvSponsorHome from '@/components/jm/adv/sponsor/home.vue'
import jmAdvSponsorList from '@/components/jm/adv/sponsor/list.vue'
import jmAdvSponsorAdd from '@/components/jm/adv/sponsor/add.vue'
import jmAdvSponsorUpdate from '@/components/jm/adv/sponsor/update.vue'
//广告投放商素材管理
import jmAdvMeaterialHome from '@/components/jm/adv/meaterial/home.vue'
import jmAdvMeaterialList from '@/components/jm/adv/meaterial/list.vue'
import jmAdvMeaterialAdd from '@/components/jm/adv/meaterial/add.vue'
import jmAdvMeaterialUpdate from '@/components/jm/adv/meaterial/update.vue'
//广告投放商订单管理
import jmAdvOrderHome from '@/components/jm/adv/order/home.vue'
import jmAdvOrderList from '@/components/jm/adv/order/list.vue'
import jmAdvOrderAdd from '@/components/jm/adv/order/add.vue'
import jmAdvOrderUpdate from '@/components/jm/adv/order/update.vue'

export default [{
		path: 'adv',
		name: 'adv',
		component: jmAdvHome,
		children: [{ //广告投放商
			path: 'sponsor',
			name: 'sponsor',
			component: jmAdvSponsorHome,
			children: [{
				path: 'list',
				name: 'jm/adv/sponsor/list',
				component: jmAdvSponsorList
			}, {
				path: 'add',
				name: 'jm/adv/sponsor/add',
				component: jmAdvSponsorAdd
			}, {
				path: 'update',
				name: 'jm/adv/sponsor/update',
				component: jmAdvSponsorUpdate
			}]
		},{ //素材
			path: 'meaterial',
			name: 'meaterial',
			component: jmAdvMeaterialHome,
			children: [{
				path: 'list',
				name: 'jm/adv/meaterial/list',
				component: jmAdvMeaterialList
			}, {
				path: 'add',
				name: 'jm/adv/meaterial/add',
				component: jmAdvMeaterialAdd
			}, {
				path: 'update',
				name: 'jm/adv/meaterial/update',
				component: jmAdvMeaterialUpdate
			}]
		},{ //订单管理
			path: 'order',
			name: 'order',
			component: jmAdvOrderHome,
			children: [{
				path: 'list',
				name: 'jm/adv/order/list',
				component: jmAdvOrderList
			}, {
				path: 'add',
				name: 'jm/adv/order/add',
				component: jmAdvOrderAdd
			}, {
				path: 'update',
				name: 'jm/adv/order/update',
				component: jmAdvOrderUpdate
			}]
		}]
	}
]



// WEBPACK FOOTER //
// ./src/router/jm/adv/adv.js